export const getRefName = (action) =>
  action && action.meta && action.meta.args && action.meta.args.refName;
